export interface tab {
    page: string
    key: string
    url: string
}

export const TRAININGDATA: tab[] = [
    {
        page: 'dashboard',
        key: 'DASHBOARD',
        url: '&page=admin/dashboard'
    },
    {
        page: 'training',
        key: 'TRAINING',
        url: '&page=admin/training'
    },
    {
        page: 'schedule',
        key: 'CLASSES.SCHEDULE',
        url: '&page=admin/bookings'
    },
    {
        page: 'locations',
        key: 'LOCATIONS',
        url: '&page=admin/booking-locations'
    },
    {
        page: 'classtypes',
        key: 'CLASSES.CLASSTYPES',
        url: '&page=admin/booking-types/active'
    },
    {
        page: 'list',
        key: 'MEMBER_LIST',
        url: '&page=admin/member/list'
    },
    {
        page: 'addMembers',
        key: 'ADD_MEMBERS',
        url: '&units=i&page=admin/member/add'
    },
    {
        page: 'pendingMembers',
        key: 'PENDING_MEMBERS',
        url: '&page=admin/halo/pending-member/list'
    },
    {
        page: 'massEmails',
        key: 'PRMOTE_MASS_EMAILS',
        url: '&page=admin/mass-email/list/completed'
    },
    {
        page: 'emailWizard',
        key: 'PRMOTE_EMAIL_WIZARD',
        url: '&page=admin/mass-email/create'
    },
    {
        page: 'memberPathways',
        key: 'PRMOTE_MEMBER_PATHWAYS',
        url: '&page=admin/email-pathways/list'
    },
    {
        page: 'membersChallenges',
        key: 'CHALLENGES',
        url: '&page=admin/challenges/live-challenges'
    }
    
]
